<template>
    <Tiles>
        <div
            v-for="(item, index) in items"
            :key="item.id"
            :class="index < 15 ? 'tile-animate-in' : ''"
            :style="index < 15 ? { 'animation-delay': `${index * 0.1}s` } : {}"
            style="display: contents;"
        >
            <Tile
                :to="{ name: 'artist', params: { id: item.id } }"
                :title="item.name" 
                :image="item.image"
                :square="false"
                :small="false"
                :allow-h-scroll="false">
                <template #text>
                    <div class="text-sm">
                        <strong>{{ item.albumCount }}</strong> {{ $tt('专辑') }}
                    </div>
                </template>
                <template #play>
                    <div class="absolute top-[43%] z-10 left-[39%] play-icon cursor-pointer" @click="playNow(item.id)">
                        <svg class="fill-primary w-12 h-12 hover:fill-accent transition-colors duration-300" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2415" width="32" height="32"><path d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM383.232 287.616v448l384-223.104-384-224.896z" p-id="2416"></path></svg>
                    </div>
                </template>
            </Tile>
        </div>
    </Tiles>
</template>
<script>
    import Tiles from '@/components/library/Tiles'
    import Tile from '@/components/library/Tile'
    export default {
        components: {
            Tiles, Tile
        },
        props: {
            items: { type: Array, required: true }
        },
        created() {
        },
        methods: {
            async playNow(id) {
                const tracks = await this.$api.subsonic.getTracksByArtist(id)
                return this.$store.dispatch('playTrackList', {
                    tracks: tracks
                })
            }
        }
    }
</script>
<style>
.play-icon {
    display: none;
}
.tile-img:hover .play-icon {
    display: block;
}

/* 动画应用到 Tile 组件内部的 .group 元素 */
.tile-animate-in + * .group {
    opacity: 0;
    animation: tileFadeIn 0.5s ease-out forwards !important;
    animation-delay: inherit !important;
}

/* 动画关键帧 */
@keyframes tileFadeIn {
    0% {
        opacity: 0;
        transform: translateY(20px) scale(0.9);
    }
    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}
</style>
